import { render, staticRenderFns } from "./ClientCreateModal.vue?vue&type=template&id=52317b5d&"
import script from "./ClientCreateModal.vue?vue&type=script&lang=js&"
export * from "./ClientCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientCreateModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports